/** B-07 (16/09/2026) : quand l'e-mail d'invitation n'a pas pu partir,
 *  l'enveloppe est bien envoyee mais le signataire n'a rien recu. Le lien
 *  est alors montre ICI, une seule fois : il n'est jamais reaffiche ensuite
 *  (seule une relance en cree un nouveau). */
import { useState } from "react";

import type { Invitation } from "../api";

export function LiensATransmettre({ liens }: { liens: Invitation[] }) {
  const [copie, setCopie] = useState<string | null>(null);

  const copier = async (lien: string) => {
    try {
      await navigator.clipboard.writeText(lien);
      setCopie(lien);
    } catch {
      setCopie(null);
    }
  };

  return (
    <div className="alert alert--warning">
      <p style={{ margin: "0 0 0.5rem" }}>
        <strong>
          {liens.length > 1
            ? "Ces signataires n'ont pas reçu d'e-mail."
            : "Ce signataire n'a pas reçu d'e-mail."}
        </strong>{" "}
        Transmettez-leur le lien vous-même. Chaque lien est personnel : il donne accès à la signature
        de cette seule personne.
      </p>
      {liens.map((l) => (
        <div key={l.signer_id} style={{ marginBottom: "0.5rem" }}>
          <div>{l.email}</div>
          <code style={{ wordBreak: "break-all" }}>{l.link}</code>{" "}
          <button type="button" className="btn btn--link" onClick={() => void copier(l.link)}>
            {copie === l.link ? "Copié" : "Copier"}
          </button>
        </div>
      ))}
      <p className="muted" style={{ margin: 0 }}>
        Ce lien ne sera plus affiché après avoir quitté cet écran.
      </p>
    </div>
  );
}
